import React, {Fragment, useState} from "react";
import AddSim from "../../components/Modal/AddSim";
import CommonHeader from "../../components/Headers/CommonHeader";
import SafeView from "../../components/safeView/SafeView";
import ProtectedContent from "../../components/ProtectedContent";
import PageURLContextProvider from "../../contexts/pageURLContext";
import SimsTable from "./simsTable";

const SimComponent = () => {
  const [modalStatus, setModalStatus] = useState(false);

  return (
    <SafeView>
      <ProtectedContent perms={["view_sim"]} showFallback>
        <Fragment>
          {modalStatus && (
            <AddSim open={modalStatus} onClose={() => setModalStatus(false)} />
          )}
          <ProtectedContent perms={["add_sim"]}>
            <CommonHeader
              content={"Add SIM"}
              handleAddClick={() => setModalStatus(true)}
              testID={"add_sim"}
            />
          </ProtectedContent>
          <div className="table-container">
            <SimsTable />
          </div>
        </Fragment>
      </ProtectedContent>
    </SafeView>
  );
};

const Sim = () => {
  return (
    <PageURLContextProvider>
      <SimComponent />
    </PageURLContextProvider>
  );
};

export default Sim;
